import CGAdConfig from 'types/CarGurusAdConfig';
import { Targeting } from './CarGurusAds';

interface Config {
  targeting: Targeting;
}

export default class CarGurusAdConfig {
  config: Config;

  constructor(config: Config) {
    this.config = config;
  }

  toJSON(): CGAdConfig {
    return {
      targeting: this.config.targeting,
    };
  }
}
